module.exports = __webpack_public_path__ + "static/media/UB.3acc24fa.svg";